export const BadgeLayoutStyle =
  'inline-flex items-center h-6 px-[6px] py-[2px] rounded-[8px] font-bold'
